import { getHeaders } from './fetch';
import { AWS_CREDENTIALS_URL as credentialsUrl, PUBLISH_COMMUNICATOR_URL as publishUrl, SUBSCRIBE_COMMUNICATOR_URL as subscribeUrl } from './config';
import { Emitter as authenticationEmitter } from './authentication';
import { create } from 'cloudswept-comm';

const communicator = create({
  credentialsUrl,
  publishUrl,
  subscribeUrl,
  getHeaders,
  authenticationEmitter
});

export const listen = communicator.listen;
export const listenWithEmitter = communicator.listenWithEmitter;
export const publish = communicator.publish;


// WEBPACK FOOTER //
// ./src/services/communicator.js